<template>
  <div>
    <div class="px-md-12 px-lg-12 pr-4 pt-12">
      <div class="mb-4">
        <span class="my-title">
          Preencha a Declaração <br />
          Pessoal de Saúde – DPS
        </span>
      </div>

      <v-row dense class="ma-0 pa-0">
        <v-form
          ref="form"
          class="d-flex justify-center align-center flex-wrap mx-auto"
        >
          <v-col cols="12" sm="12" md="6" lg="6">
            <strong>Peso</strong>
            <v-text-field
              v-model="user.weight"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Peso obrigatório']"
              outlined
              type="number"
              min="0"
              placeholder="80"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="6">
            <strong>Altura</strong>
            <v-text-field
              v-model="user.height"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Peso obrigatório']"
              outlined
              type="number"
              min="0"
              placeholder="1.80"
            >
            </v-text-field>
          </v-col>
        </v-form>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong> Você sofre ou já sofreu de alguma doença crônica? </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.chronicDisease = true"
            class="mr-3"
            :class="user.chronicDisease ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.chronicDisease = false"
            :class="!user.chronicDisease ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Você já foi submetido a algum procedimento hospitalar?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.hospitalProcedure = true"
            class="mr-3"
            :class="user.hospitalProcedure ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.hospitalProcedure = false"
            :class="!user.hospitalProcedure ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Você faz uso diário ou habitual de medicamentos? (Em caso de uso de
            pílula contraceptiva e/ou medicamento para calvície, assinale
            "Não".)
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.medicationRegularly = true"
            class="mr-3"
            :class="user.medicationRegularly ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.medicationRegularly = false"
            :class="!user.medicationRegularly ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Sofre de alguma deficiência nos órgãos, nos membros ou nos sentidos?
            (Não é necessário informar deficiência visual menor que 10 graus
            para miopia, astigmatismo ou hipermetropia.)
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.deficient = true"
            class="mr-3"
            :class="user.deficient ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.deficient = false"
            :class="!user.deficient ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Algum membro da sua família (pais ou irmãos) sofre ou já sofreu de
            alguma doença grave?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.familiarWithDisease = true"
            class="mr-3"
            :class="user.familiarWithDisease ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.familiarWithDisease = false"
            :class="!user.familiarWithDisease ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Você consome bebida alcoólica mais do que 3 vezes por semana?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.consumesAlcohol = true"
            class="mr-3"
            :class="user.consumesAlcohol ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.consumesAlcohol = false"
            :class="!user.consumesAlcohol ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Faz ou fez uso de tabaco nos últimos 3 anos (mais de 30 unidades por
            dia)?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.consumeTobacco = true"
            class="mr-3"
            :class="user.consumeTobacco ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.consumeTobacco = false"
            :class="!user.consumeTobacco ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Faz ou fez uso de algum tipo de droga nos últimos 5 anos?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.consumeDrugs = true"
            class="mr-3"
            :class="user.consumeDrugs ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.consumeDrugs = false"
            :class="!user.consumeDrugs ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Você pratica alguma modalidade esportiva em caráter profissional ou
            amador?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.practiceSports = true"
            class="mr-3"
            :class="user.practiceSports ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.practiceSports = false"
            :class="!user.practiceSports ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Sofreu alguma alteração de peso (perda ou ganho) de mais de 10kg nos
            últimos 6 meses?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.lostMoreThanTenKilos = true"
            class="mr-3"
            :class="user.lostMoreThanTenKilos ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.lostMoreThanTenKilos = false"
            :class="!user.lostMoreThanTenKilos ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Alguma companhia já recusou, agravou/ajustou ou cancelou algum
            seguro de vida, acidentes pessoais ou coberturas de risco de
            previdência em seu nome?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.canceledInsurance = true"
            class="mr-3"
            :class="user.canceledInsurance ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.canceledInsurance = false"
            :class="!user.canceledInsurance ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>
      </v-row>
      <div class="mb-6 mt-6 mr-2 d-flex justify-end">
        <v-btn
          class="next-button"
          @click="submit"
          elevation="0"
          color="#00C7BA"
          height="44"
          :loading="loading"
        >
          <strong class="mr-2 next-button-label"> Enviar Solicitação </strong>
          <v-icon color="white">mdi-arrow-right-circle-outline</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import moment from "moment";

export default {
  name: "Payment",

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      user: {
        chronicDisease: false,
        hospitalProcedure: false,
        medicationRegularly: false,
        deficient: false,
        familiarWithDisease: false,
        consumesAlcohol: false,
        consumeTobacco: false,
        consumeDrugs: false,
        practiceSports: false,
        lostMoreThanTenKilos: false,
        canceledInsurance: false,
      },
      generalOptions: [
        { text: "Sim", value: true },
        { text: "Não", value: false },
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const storagedData = JSON.parse(
          localStorage.getItem("@GlobusVida:data")
        );
        const secures = JSON.parse(localStorage.getItem("covers"));
        const monthValue = JSON.parse(localStorage.getItem("monthValue"));
        this.user = {
          ...this.user,
          ...storagedData,
          covers: secures,
          monthValue: monthValue,
        };

        localStorage.setItem("@GlobusVida:data", JSON.stringify(this.user));

        this.user.dataNascimento = moment(this.user.dataNascimento).format(
          "YYYY/MM/DD"
        );

        this.apiService
          .post("api/vida/criarcota", this.user)
          .then(() => {
            this.loading = false;
            this.$toast.success("Solicitação enviada!");
            this.$emit("confirm");
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.$toast.error("Erro ao enviar solicitação!");
          });
      }
    },
  },
};
</script>

<style scoped>
.active {
  background-color: #00c7ba !important;
  color: #fff !important;
}
</style>
